import Pages from "./components/Pages";
import ToastProvider from "./components/ToastProvider";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div>
      <ScrollToTop />
      <ToastProvider />
      <Pages />
    </div>
  );
}

export default App;
